module.exports = __webpack_public_path__ + "static/media/xboxseriespumpkin.19eea3fd.jpeg";